import makeStyles from '@mui/styles/makeStyles'
import Alert, { AlertProps } from '@mui/material/Alert'
import { CommonLabelProps, ContentWrapper, MaybeAlertType } from '.'
import { getElementId } from '../utils'
import { useTextOrTranslation } from '../hooks'

const useStyles = makeStyles(() => ({
  visibleAlert: {
    width: '100%',
    marginLeft: '32px',
    marginTop: '1rem'
  }
}))

interface AlertComponentProps extends CommonLabelProps {
  showAlert?: boolean
}

export const AlertComponent = ({
  label,
  labelTranslationId,
  showAlert = false
}: AlertComponentProps) => {
  const classes = useStyles()

  const content = useTextOrTranslation(label, labelTranslationId)

  return (
    <ContentWrapper showContent={showAlert}>
      <Alert
        className={classes.visibleAlert}
        id={getElementId()}
        variant="outlined"
        severity="warning"
      >
        {content}
      </Alert>
    </ContentWrapper>
  )
}

export interface SubmitAlertProps extends Pick<AlertProps, 'sx' | 'variant'> {
  alertType: MaybeAlertType
}

export const SubmitAlert = ({ alertType, sx, variant }: SubmitAlertProps) => {
  switch (alertType) {
    case undefined:
      return null
    default:
      return (
        <Alert
          variant={variant || 'outlined'}
          severity={alertType.severity}
          sx={{ py: '2px', ...sx }}
        >
          {alertType.message}
        </Alert>
      )
  }
}
